import axios from 'axios';

export function getPesertaInfo() {
  let nip = '';
  let nama = '';

  if (typeof localStorage === 'undefined') return { nip, nama };

  if (localStorage.getItem('nip_peserta')) {
    nip = localStorage.getItem('nip_peserta');
  }
  if (localStorage.getItem('nama_peserta')) {
    nama = localStorage.getItem('nama_peserta');
  }
  if ((!nip || !nama) && localStorage.getItem('data_peserta')) {
    try {
      const data = JSON.parse(localStorage.getItem('data_peserta'));
      if (data) {
        nip = nip || data.nip || data.username || '';
        nama = nama || data.nama || data.name || '';
      }
    } catch (e) {
      // ignore
    }
  }
  if ((!nip || !nama) && localStorage.getItem('session_username')) {
    nip = nip || localStorage.getItem('session_username');
    nama = nama || localStorage.getItem('session_name') || '';
  }
  if ((!nip || !nama) && localStorage.getItem('user')) {
    try {
      const data = JSON.parse(localStorage.getItem('user'));
      if (data) {
        nip = nip || data.u_nip || data.nip || data.username || '';
        nama = nama || data.nama || data.name || '';
      }
    } catch (e) {
      // ignore
    }
  }
  return { nip, nama };
}

export function getPesertaUsername() {
  const info = getPesertaInfo();
  if (info.nip) return info.nip;
  if (typeof localStorage !== 'undefined' && localStorage.getItem('username')) {
    return localStorage.getItem('username');
  }
  return 'peserta';
}


export async function logActivity(menu, type) {
  if (localStorage.access_token) {
    try {
      await axios({
        method: 'post',
        url: process.env.VUE_APP_BACKEND_URL_VERSION + 'log/activity/create',
        data: {
          menu: menu,
          type: type,
        },
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        }
      });
    } catch (error) {
      console.error('Error logging activity:', error);
    }
  }
}

let lastPesertaLog = { key: null, time: 0 };

export async function logActivityPeserta(menu = 'Master Blueprint', type = 'Lihat detail blueprint', customUrl = null) {
  try {
    const username = getPesertaUsername();
    const token =
      localStorage.access_token ||
      localStorage.access_token_peserta ||
      localStorage.session;

    const currentUrl = customUrl || (typeof window !== 'undefined' ? window.location.href : '');

    // Cegah log duplikat beruntun dalam rentang 2 detik untuk aksi yang sama
    const logKey = `${username}_${menu}_${type}_${currentUrl}`;
    const now = Date.now();
    if (lastPesertaLog.key === logKey && now - lastPesertaLog.time < 2000) {
      return;
    }
    lastPesertaLog = { key: logKey, time: now };

    await axios({
      method: 'post',
      url: process.env.VUE_APP_BACKEND_URL_VERSION + 'log/activity-peserta/create',
      data: {
        username: username,
        menu: menu,
        type: type,
        url: currentUrl,
      },
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        'X-Frontend-Url': currentUrl,
        'X-Username': username,
      }
    });
  } catch (error) {
    console.error('Error logging participant activity:', error);
  }
}

